import React from 'react';
import PropTypes from 'prop-types';
import { KeyboardDatePicker } from '@material-ui/pickers';
import { Typography } from '@material-ui/core';
import set from 'date-fns/set';

const FormBirthDateField = ({
  input,
  label,
  helperText,
  meta: { touched, error },
}) => (
    <React.Fragment>
      {label ? <Typography variant="caption" display="block">{label}</Typography> : null}
      <KeyboardDatePicker
        error={touched && error ? true : false}
        helperText={touched && error}
        inputVariant="outlined"
        margin="dense"
        clearable
        okLabel="OK"
        onChange={value => value ? input.onChange(set(value, { hours: 12, minutes: 0 })) : input.onChange(null)}
        format="dd.MM.yyyy"
        value={input.value}
        cancelLabel="Anuluj"
        clearLabel="Wyczyść"
        invalidLabel="Wybierz ..."
        autoOk
        disableFuture
        openTo="year"
        views={["year", "month", "date"]}
      />
      {helperText && <Typography variant="caption" component="div">{helperText}</Typography>}
    </React.Fragment>
  );

FormBirthDateField.propTypes = {
  input: PropTypes.object,
  label: PropTypes.string,
  meta: PropTypes.object,
  helperText: PropTypes.string,
};

export default FormBirthDateField;



// WEBPACK FOOTER //
// ./src/components/form/FormBirthDateField.js